import * as moment from 'moment';

import { CompanyDocumentsForm } from './company-documents.form';

import {
    DocumentStatusesEnum,
    AuthApiService,
    CompanyExtendedModel,
    CompanyDocumentModel,
    CompanyDocumentsAtomicService,
    DocumentTypesEnum,
    CompanyDocumentAndFilesInterface,
    CompanyDocumentAndFilesModel
} from '@spa/api';

import { SelectControl, Helper } from '../../../../../shared/classes';

import { CompanyProofOfAddressControl, CompanyProofOfAddressDocumentTypeSelector } from '../../../../../../assets/descriptors';

export class CompanyProofOfAddressForm extends CompanyDocumentsForm {
    constructor(
        company: CompanyExtendedModel,
        authApiService: AuthApiService,
        companyDocumentsAtomicService: CompanyDocumentsAtomicService
    ) {
        super(company, authApiService,
            companyDocumentsAtomicService);
    }

    protected getDocumentTypeIds(): string[] {
        return Helper.enumsHelper().getProofOfAddressDocumentTypes().getTypeKeys();
    }

    protected getInitialControlStructure(): SelectControl {
        return CompanyProofOfAddressControl();
    }

    protected getCompanyDocumentInputModel(file: File): CompanyDocumentAndFilesModel {
        const companyDocumentUploadModel: CompanyDocumentAndFilesInterface = {
            documentType: DocumentTypesEnum.ProofOfAddress,
            companyId: this.company.id,
            fileName: file.name,
            subDocumentType: this.documentTypeControl.value as string,
            uploadedBy: this.authApiService.getAuthenticatedUser().id,
            reviewSummary: this.reviewSummary,
            isHiddenForClient: this.hiddenDocument,
            files: [file],
            fileStorageIds: ['']
        };

        return new CompanyDocumentAndFilesModel(
            companyDocumentUploadModel
        );
    }
    initDocument(documents: CompanyDocumentModel[]): void {
        if (documents && documents.length > 0) {
            const waitingForApprovalStatuses =
                [DocumentStatusesEnum.New, DocumentStatusesEnum.InReview] as number[];

            const filteredDocuments = documents
                .filter((document: CompanyDocumentModel) => {
                    return (
                        (this.getDocumentTypeIds().indexOf(document.subDocumentType) >= 0) &&
                        (waitingForApprovalStatuses.indexOf(document.status) >= 0)
                    );
                })
                .sort((current: CompanyDocumentModel, next: CompanyDocumentModel) => {
                    return moment(next.uploadStamp).unix() - moment(current.uploadStamp).unix();
                });

            if (filteredDocuments[0]) {
                this.document = filteredDocuments[0];

                this.documentTypeControl.value = filteredDocuments[0].subDocumentType;
            }

            setTimeout(() => {
                if (filteredDocuments[0]) {
                    this.documentSubject.next(filteredDocuments[0].fileStorageIds[0]);
                }
            }, 0);
        }
    }

    getValidationErrors(): { [key: string]: string[] } {
        return {
            [CompanyProofOfAddressDocumentTypeSelector]: this.documentTypeControl.errors
        };
    }
}
